import React, { useContext, useRef, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { RotatingSquare } from "react-loader-spinner";
import { AuthContext } from "../../../../Contexts/AuthContext/AuthProvider";
const PlatformTypeAdd = () => {
    const { authUser } = useContext(AuthContext);
    const [errorMessage, setErrorMessage] = useState([]);
    const refSubmitDis = useRef();

    const [Image, setImage] = useState("");

    const handleImage = (e) => {
        setImage(e.target.files[0]);
    };

    const handleSubmitData = (event) => {
        event.preventDefault();
        refSubmitDis.current.setAttribute("disabled", true);
        // Clear previous errors
        setErrorMessage({});

        try {

            const formData = new FormData(event.currentTarget);
            // Append selected image
            if (Image) {
                formData.set("image", Image);
            }

            const config = {
                headers: {
                    "content-type": "multipart/form-data",
                },
            };
            axios
                .post(
                    `https://api.velormall.com/api/admin/platform-type/create`,
                    formData,
                    config
                )
                .then((response) => {

                    if (response?.data?.success) {
                        event.target.reset();
                        toast.success(`${response?.data.message}`, {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                        setImage('');
                        refSubmitDis.current.removeAttribute("disabled");

                    }

                })
                .then((data) => {
                    toast.success(`${data.message}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                })
                .catch((error) => {
                    setErrorMessage(error?.response?.data?.errors)
                    refSubmitDis.current.removeAttribute("disabled");
                });
        } catch (error) {

        }
    };



 return (
            <>
                <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
                    <h6 className="page-title">Platform Type Add</h6>
                </div>

                <div className="row">
                    <div className="col-lg-12">
                        <div className="card mb-4">
                            <form onSubmit={handleSubmitData}>
                                <div className="card-body">
                                    <div className="payment-method-item">
                                        <div className="payment-method-body">
                                            <div className="row">
                                                <div className=" col-md-3 ">
                                                    <div className="form-group">
                                                        <label htmlFor="heading" className="required">
                                                            Name
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="name"
                                                            id="heading"
                                                        />
                                                        {errorMessage?.name && (
                                                            <span className="text-danger pt-2">
                                                                {errorMessage?.name?.msg}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className=" col-md-3 ">
                                                    <div className="form-group">
                                                        <label htmlFor="heading" className="required">
                                                            Commission (%)
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="commission"
                                                            id="heading"
                                                        />
                                                        {errorMessage?.commission && (
                                                            <span className="text-danger pt-2">
                                                                {errorMessage?.commission?.msg}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className=" col-md-3 ">
                                                    <div className="form-group">
                                                        <label htmlFor="heading" className="required">
                                                            Start Price
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="startPrice"
                                                            id="heading"
                                                        />
                                                        {errorMessage?.startPrice && (
                                                            <span className="text-danger pt-2">
                                                                {errorMessage?.startPrice?.msg}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className=" col-md-3 ">
                                                    <div className="form-group">
                                                        <label htmlFor="heading" className="required">
                                                            End Price
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="endPrice"
                                                            id="heading"
                                                        />
                                                        {errorMessage?.endPrice && (
                                                            <span className="text-danger pt-2">
                                                                {errorMessage?.endPrice?.msg}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">

                                                <div className=" col-md-3 ">
                                                    <div className="form-group">
                                                        <label htmlFor="heading" className="required">
                                                            Vip Number
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="vip"
                                                            id="heading"
                                                        />
                                                        {errorMessage?.vip && (
                                                            <span className="text-danger pt-2">
                                                                {errorMessage?.vip?.msg}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className=" col-md-3 ">
                                                    <div className="form-group">
                                                        <label htmlFor="heading" className="required">
                                                            Start Profit Price
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="startProfit"
                                                            id="heading"
                                                        />
                                                        {errorMessage?.startProfit && (
                                                            <span className="text-danger pt-2">
                                                                {errorMessage?.startProfit?.msg}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className=" col-md-3 ">
                                                    <div className="form-group">
                                                        <label htmlFor="heading" className="required">
                                                            End Profit Price
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="endProfit"
                                                            id="heading"
                                                        />
                                                        {errorMessage?.endProfit && (
                                                            <span className="text-danger pt-2">
                                                                {errorMessage?.endProfit?.msg}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className=" col-md-3 ">
                                                    <div className="form-group">
                                                        <label htmlFor="heading" className="required">
                                                            Daily Task Limit
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="dailyTaskLimit"
                                                            id="heading"
                                                        />
                                                        {errorMessage?.dailyTaskLimit && (
                                                            <span className="text-danger pt-2">
                                                                {errorMessage?.dailyTaskLimit?.msg}
                                                            </span>
                                                        )}
                                                    </div>

                                                </div>

                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Image</label>
                                                        <div className="image-upload">
                                                            <div className="thumb">
                                                                <div className="avatar-edit">
                                                                    <input
                                                                        type="file"
                                                                        onChange={handleImage}
                                                                        className="profilePicUpload"
                                                                        id="profilePicUpload0"
                                                                        accept=".jpg, .png, .jpeg"
                                                                    />
                                                                    <label
                                                                        htmlFor="profilePicUpload0"
                                                                        className="bg--primary"
                                                                    >
                                                                        Image
                                                                    </label>
                                                                    <small class="mt-2  ">
                                                                        Supported files: <b>jpeg, jpg, png</b>. |
                                                                        Will be resized to:
                                                                        <b>800x800</b>
                                                                        px.
                                                                    </small>
                                                                </div>
                                                                {errorMessage?.image && (
                                                                    <span className="text-danger pt-2">
                                                                        {errorMessage?.image?.msg}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <button
                                        type="submit"
                                        ref={refSubmitDis}
                                        className="btn btn-primary w-100 h-45"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </>
        );
};
export default PlatformTypeAdd;
